import styled from "styled-components";
import DXFMaterialItem from "./DXFMaterialItem";
import {DXFConfigurateurContext} from "../../context/dxfContext";
import {device, TYPE_DECOUPE, TYPE_PLIAGE} from "../../helper/constants";
import {DECOUPE_FORMS, MATERIAL_SHADES, MATERIAL_THICKNESS, PLIAGE_FORMS} from "../../helper/materials";
import DXFShadeItem from "./DXFShadeItem";
import DXFThicknessItem from "./DXFThicknessItem";
import DXFCommandContainer from "./DXFCommandContainer";
import MaterialItem from "./DXFMaterialItem";
import {getFormFromMid, getMaterialAndShadeFromCurrentPath} from "../../helper/function";
import ShadeItem from "../Configurateur/ShadeItem";
import ThicknessItem from "../Configurateur/ThicknessItem";
import Devis from "../Devis";
const {
    element: {
        useContext,
    },
} = wp;

const Wrapper = styled.div`
    width: 100%;
    padding: 30px;
    background-color: #fff;
    min-height: 150px;
    justify-content: center;
    display: flex;
    
    &.hjt-modal {
        flex-direction: column;
        align-items: center;
    }
    @media ${device.mobile} {
        padding: 0;
        height: calc(100vh - 265px);
        overflow: scroll;
        display: block;
    }
    @media ${device.tablet} {
        padding: 0;
    }
`;
const ListContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
    justify-content: start;
    position: relative;
    padding: 10px;
    width: 100%;
    
    &.w-50 {
        width: 50%;
    }
    & p {
        font-size: 18px;
        font-weight: bold;
        color: #144344;
    }
    @media ${device.mobile} {
        &.w-50 {
            width: 100%;
        }
        justify-content: center;
    }
`;
const MyContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  @media ${device.mobile} {
    width: 100%;
    flex-direction: column;
  }
`;

const SectionLabel = styled.p`
  text-align: center;
  margin-bottom: 0 !important;
`;

const MaterialList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
`;

const MaterialListStretch = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  gap: 10px;
  flex-wrap: wrap;
`;

export default function DXFStepBody({onSelect}) {

    const {
        currentStep,
        currentMaterial,
        currentShade,
    } = useContext(DXFConfigurateurContext);

    const currentPath = window.location.pathname;

    const {materiel} = getMaterialAndShadeFromCurrentPath(currentPath);

    const handleSelect = () => {
        setTimeout(() => onSelect(), 300);
    }

    return (
        <>
            {currentStep === 1 && (
                <Wrapper className="hjt-modal">
                    <MyContainer>
                        { (materiel === 'metal' || currentPath === '/') ? (
                            <ListContainer>
                                <SectionLabel>Métal</SectionLabel>
                                <MaterialList>
                                    <MaterialItem mid={'acier'} handleSelect={handleSelect} />
                                    <MaterialItem mid={'inox'} handleSelect={handleSelect}/>
                                    <MaterialItem mid={'aluminium'} handleSelect={handleSelect}/>
                                    <MaterialItem mid={'laiton'} handleSelect={handleSelect}/>
                                </MaterialList>
                            </ListContainer>
                        ) : ''}

                        { (materiel === 'bois' || currentPath === '/') ? (
                            <ListContainer>
                                <SectionLabel>Panneau Bois</SectionLabel>
                                <MaterialList>
                                    <MaterialItem mid={'bois-brut'} handleSelect={handleSelect} />
                                    <MaterialItem mid={'melamine'} handleSelect={handleSelect} />
                                </MaterialList>
                            </ListContainer>
                        ) : ''}
                    </MyContainer>
                    <MyContainer>
                        { (materiel === 'plexi' || currentPath === '/') ? (
                            <ListContainer>
                                <SectionLabel>Plexi</SectionLabel>
                                <MaterialList>
                                    <MaterialItem mid={'plexi-pmma'} handleSelect={handleSelect}/>
                                    <MaterialItem mid={'plexi-polycarbonate'} handleSelect={handleSelect}/>
                                </MaterialList>
                            </ListContainer>
                        ) : ''}

                        { (materiel === 'miroir-et-verre-old' || currentPath === '/old') ? (
                            <ListContainer>
                                <SectionLabel>Miroir & verre</SectionLabel>
                                <MaterialList>
                                    <MaterialItem mid={'miroir'} handleSelect={handleSelect}/>
                                    <MaterialItem mid={'verre'} handleSelect={handleSelect}/>
                                </MaterialList>
                            </ListContainer>
                        ) : '' }
                    </MyContainer>
                </Wrapper>
            )}
            {currentStep === 2 && currentMaterial !== null && (
                <Wrapper>
                    {(currentMaterial === 'miroir' || currentMaterial === 'verre') ? (
                        <Devis message="Pour les verres et miroirs, merci de nous contacter via le formulaire de contact ou appelez nous pour un devis." />
                    ) : (
                        <ListContainer style={{marginTop: "10px"}}>
                            <MaterialList>
                                {
                                    Object.values(MATERIAL_SHADES[currentMaterial]).map(item => {
                                        return <DXFShadeItem mid={item.mid} imageUrl={item.image} label={item.label}  handleSelect={handleSelect}/>
                                    })
                                }
                            </MaterialList>
                        </ListContainer>
                    )}

                </Wrapper>
            )}
            {currentStep === 3 && currentMaterial !== null && currentShade &&(
                <Wrapper>
                    <ListContainer style={{marginTop: "10px"}}>
                        <MaterialListStretch>
                            {
                                MATERIAL_THICKNESS[currentShade].map(value => {
                                    return <DXFThicknessItem value={value}  handleSelect={handleSelect}/>
                                })
                            }
                        </MaterialListStretch>
                    </ListContainer>
                </Wrapper>
            )}
            {currentStep === 4 && (
                <Wrapper>
                    <DXFCommandContainer material={currentMaterial} shade={currentShade}/>
                </Wrapper>
            )}
        </>
    )
}